import { pdfPrint } from '../pdf-print'

// eslint-disable-next-line no-undef
const object = ccObject
pdfPrint(object)
